export default __webpack_public_path__ + "static/media/jaipuria.3d5fd554.png";